import { generatePath } from 'react-router-dom';
import {
  STOCK_ACTIVITIES,
  STOCK_ACTIVITY_CREATE,
  STOCK_ACTIVITY_INFO,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestStockActivitiesList = async (page) => {
  const params = { page }

  return request.get(STOCK_ACTIVITIES, { params })
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestStockActivityCreate = async (params) => (
  request.post(STOCK_ACTIVITY_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestStockActivityInfo = async (id) => {
  const path = generatePath(STOCK_ACTIVITY_INFO, { id })

  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
